import React from 'react'
import styles from './gray-line.css'

function GrayLine() {
  return <div className={styles.grayLine} />
}

export default GrayLine
